import { useState } from "react";
import { faqs } from "@/mocks/contact";

export default function FAQSection() {
  const [openFaq, setOpenFaq] = useState<number | null>(null);

  return (
    <section className="py-20 bg-white">
      <div className="max-w-3xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <span className="text-xs font-semibold text-[#c8a2c8] uppercase tracking-widest">
            Preguntas frecuentes
          </span>
          <h2
            className="text-3xl font-bold text-[#2d1a0e] mt-2"
          >
            ¿Tienes Dudas?
          </h2>
        </div>
        <div className="flex flex-col gap-3">
          {faqs.map((faq, i) => (
            <div
              key={i}
              className="border border-[#c9b8f0]/40 rounded-2xl overflow-hidden"
            >
              <button
                onClick={() => setOpenFaq(openFaq === i ? null : i)}
                className="w-full flex items-center justify-between p-5 text-left cursor-pointer hover:bg-[#e0f7fa]/30 transition-colors"
              >
                <span className="font-semibold text-[#2d1a0e] text-sm pr-4">{faq.question}</span>
                <div className="w-6 h-6 flex items-center justify-center shrink-0">
                  <i
                    className={`text-[#d4607a] text-lg transition-transform duration-200 ${
                      openFaq === i ? "ri-subtract-line" : "ri-add-line"
                    }`}
                  ></i>
                </div>
              </button>
              {openFaq === i && (
                <div className="px-5 pb-5">
                  <p className="text-[#6b5b6e] text-sm leading-relaxed">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}